module.exports = __webpack_public_path__ + "static/mosque-15e281a1efa267c953db425c1ab591b2.jpeg";